module.exports = __webpack_public_path__ + "static/media/law.e3b2608f.jpg";